import Bout from "../../bout/Bout";
import Screen from "../Screen";
import SpeedBar from "./SpeedBar";

export default class EnemySlot {
	constructor(enemy, mob, hero, callback) {
		//console.log(enemy)
		//console.log(mob)
		this.mob = mob;
		this.hero = hero;
		this.isHero = true;
		this.enemy = enemy;
		if (hero) {
			this.isHero = false;
		}
		this.callback = callback;
		this.id = EnemySlot.IDS++;
		this.died = false;
	}
	init(initiative) {
		let mc = jQuery("#template-mob-slot").clone();
		mc.attr("id", "mobslo" + EnemySlot.ENUM++);
		this.mc = mc;

		if (this.isHero) {
			jQuery(".js-name", this.mc).hide();
			jQuery(".js-stars", this.mc).hide();
		} else {
			let lore = this.mob.lore;
			jQuery(".js-name", this.mc).text(lore.name);
			jQuery(".js-level", this.mc).text("" + (lore.level < 1 ? 1 : lore.level));
			for (let x = 0; x < lore.stars; x++) {
				let star = jQuery("#template-little-star").clone();
				star.removeAttr("id");
				jQuery(".js-stars", this.mc).append(star);
			}
			this.setLevels();
			jQuery(".js-target-indicator-sx", this.mc).css("background-image", "url('assets/ui/combat/target-sx.png')");
			jQuery(".js-target-indicator-dx", this.mc).css("background-image", "url('assets/ui/combat/target-dx.png')");

			this.mc.on("click", this.selectThisEnemy.bind(this));
			this.mc.css("cursor", "pointer");
		}
		this.addSprite();
		if (!this.isHero) {
			if (this.enemy.spikedLevel > 0) {

				let tmp = Math.floor(this.mob.lore.hp / 2);
				let damage = this.enemy.spikedLevel
				if (damage > 3) {
					damage = 3;
				}
				let hit = Math.floor(tmp / 3) * damage;
				this.mob.lore.hp -= hit;
			}
		}

		this.setHp();
		this.initSpeedBar(initiative);



	}

	selectThisEnemy() {
		this.dispatch({ type: EnemySlot.EVENT_SELECT_ME, data: this });
	}


	addSprite() {
		jQuery(".js-sprite", this.mc).append(this.mob.mc)
		this.mob.clip.css("left", 0)
		this.mob.clip.css("top", 0)
		this.mob.mc.css("left", 0)
		this.mob.mc.css("top", 0)
		if (this.isHero) {
			this.mob.setAnimation("idle_e");
		} else {
			this.mob.setAnimation("idle_w");
		}
	}

	setHp() {
		let perc = 1;
		if (this.isHero) {
			let lore = Bout.that.player
			jQuery(".js-hp", this.mc).text(lore.hp);
			jQuery(".js-hp-max", this.mc).text(lore.max_hp);
			perc = lore.hp / lore.max_hp;
		} else {
			let lore = this.mob.lore;
			jQuery(".js-hp", this.mc).text(lore.hp);
			jQuery(".js-hp-max", this.mc).text(lore.max_hp);
			perc = lore.hp / lore.max_hp;
		}

		jQuery(".js-health", this.mc).removeClass("text-green");
		jQuery(".js-health", this.mc).removeClass("text-yellow");
		jQuery(".js-health", this.mc).removeClass("text-red");
		/*		jQuery(".js-hp", this.mc).removeClass("text-green");
				jQuery(".js-hp", this.mc).removeClass("text-yellow");
				jQuery(".js-hp", this.mc).removeClass("text-red");
				jQuery(".js-hp-max", this.mc).removeClass("text-green");
				jQuery(".js-hp-max", this.mc).removeClass("text-yellow");
				jQuery(".js-hp-max", this.mc).removeClass("text-red");*/
		perc = perc * 100;
		//console.log(perc)
		if (perc < 25) {
			jQuery(".js-health", this.mc).addClass("text-red");
			/*jQuery(".js-hp", this.mc).addClass("text-red");
			jQuery(".js-hp-max", this.mc).addClass("text-red");*/

		} else if (perc < 50) {
			jQuery(".js-health", this.mc).addClass("text-yellow");
			/*jQuery(".js-hp", this.mc).addClass("text-yellow");
			jQuery(".js-hp-max", this.mc).addClass("text-yellow");*/

		} else {
			jQuery(".js-health", this.mc).addClass("text-green");
			/*jQuery(".js-hp", this.mc).addClass("text-green");
			jQuery(".js-hp-max", this.mc).addClass("text-green");*/

		}

	}

	setLevels() {

		let cls = EnemySlot.compareLevels(this.mob);
		jQuery(".js-name", this.mc).addClass(cls)
		jQuery(".js-stars", this.mc).addClass(cls)


	}

	static compareLevels(mob) {
		let cls = "";
		let lore = mob.lore;
		let herol = Bout.that.player.currentLevel;
		let enemyl = lore.level;

		let diff = enemyl - herol;
		if (diff === 0) {
			// uguali, verde
			cls = "text-green";
		} else {
			if (diff > 0) {
				if (diff > 3) {
					// red
					cls = "text-red";
				} else {
					// yellow
					cls = "text-orange";
				}
			} else {
				if (diff > -2) {
					// verde
					cls = "text-green";
				} else {
					// grey
					cls = "text-grey";
				}
			}
		}
		return cls;
	}


	initSpeedBar(initiative) {
		let speed
		let hasInitiative = false;
		if (this.isHero) {
			speed = Screen.that.paperdoll.getSpeedValue();
			//console.log(speed);
			if (initiative === 1) {
				hasInitiative = true;
				//console.log("Initiative HERO")
			}
		} else {
			speed = this.mob.lore.speed;
			if (initiative === 2) {
				hasInitiative = true;
				//console.log("Initiative ENEMY")
			}
		}

		this.bar = new SpeedBar(jQuery(".js-speed-bar", this.mc), this.speedbarEventsHandler.bind(this));
		this.bar.init(speed, hasInitiative);
	}

	speedbarEventsHandler(e) {
		e.data = this;
		this.dispatch(e);
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	loop() {
		this.incBarSpeed();
	}

	incBarSpeed() {
		this.bar.increment();
	}

	select(lFlag) {
		if (lFlag) {
			jQuery(".js-target-indicator", this.mc).show();
		} else {
			jQuery(".js-target-indicator", this.mc).hide();
		}
	}

	gotDamage(damage) {
		//console.log(hp)
		if (this.isHero) {
			Bout.that.player.hp -= damage;
			if (Bout.that.player.hp < 0) {
				Bout.that.player.hp = 0;
			}
		} else {
			this.mob.lore.hp -= damage;
			if (this.mob.lore.hp < 0) {
				this.mob.lore.hp = 0;
			}
		}
		this.setHp();

	}

	gotHeal() {
		//console.log(hp)
		this.setHp();
	}

	die() {
		this.mc.off("click");
		this.mc.css("cursor", "default");
		jQuery(".js-name", this.mc).hide();
		jQuery(".js-stars", this.mc).hide();
		jQuery(".js-target-indicator", this.mc).hide();
		jQuery(".js-bottom", this.mc).hide();
		this.died = true;

	}


}

EnemySlot.ENUM = 0;
EnemySlot.IDS = 0;
EnemySlot.EVENT_SELECT_ME = "eventSelectMe";

